import { useTranslations } from '@vocab/react';
import {
  Box,
  IconInfo,
  Stack,
  Dropdown,
  Columns,
  Column,
  TextField,
  Text,
} from 'braid-design-system';
import { useAtomValue } from 'jotai';

import translations from '../../../locales.vocab';
import { maintenanceEWalletMediumAtom } from '../../../usecases/Maintenance/MaintenanceStore';
import type { EWallet } from '../../../usecases/usecaseTypes';

const EwalletComponent = ({
  eWalletsOption,
  handleOnChangeEWallet,
  selectedEWalletOption,
  validEwallet,
  validAccNoOVO,
  accountNoOVO,
  handleOnChangeOVOEWallet,
}: EWallet) => {
  const { t } = useTranslations(translations);

  const maintenanceEWalletMedium = useAtomValue(maintenanceEWalletMediumAtom);

  const renderSupportedEwallets = () =>
    eWalletsOption.map((wallet: any) => (
      <option
        key={wallet.value}
        value={wallet.value}
        disabled={Boolean(maintenanceEWalletMedium?.includes(wallet.value))}
      >
        {wallet.ewalletname}
      </option>
    ));

  return (
    <Box display="flex">
      <Box marginX="xsmall">
        <Text tone="info">
          <IconInfo tone="info" />
        </Text>
      </Box>
      <Box>
        <Stack space="medium">
          <Text tone="info">{t('pay.option.ewallet.description1')}</Text>

          <Dropdown
            id="ewalletDropdown"
            label={t('select.a.ewallet')}
            placeholder={t('select.a.ewallet.placeholder')}
            onChange={handleOnChangeEWallet}
            value={selectedEWalletOption}
            tone={
              selectedEWalletOption === '' && validEwallet
                ? 'critical'
                : 'neutral'
            }
            message={
              selectedEWalletOption === '' &&
              validEwallet &&
              t('ewallet.select.a.ewallet.error')
            }
          >
            {renderSupportedEwallets()}
          </Dropdown>

          {selectedEWalletOption === 'OVO' && ( // only OVO requires account number
            <div>
              <Columns space="small">
                <Column>
                  <TextField
                    label={t('idEwallet.form.accountNo')}
                    placeholder={t('idEwallet.form.accountNo.placeholder')}
                    value={accountNoOVO}
                    onChange={handleOnChangeOVOEWallet}
                    id="accountNo"
                    tone={validAccNoOVO ? 'critical' : 'neutral'}
                    message={
                      validAccNoOVO && t('idEwallet.form.accountNo.error')
                    }
                  />
                </Column>
              </Columns>
            </div>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default EwalletComponent;
